import React from "react";

const PopularBanner = () => {
    return (
        <section className="popularBanner">
      <div >
        <img
          src="../images/philtonfilm.svg"
          alt="PHIL TON FILM"
          className="featured_image"
        />
      </div>
    
  </section>
    )
}

export default PopularBanner;
